import { Component }        from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ExportService }   from './export.service';
import { MessagesService } from '../messages/messages.service';

@Component({
  selector   : 'wor-export',
  template: require('./export.component.html')
})
export class ExportComponent {
  historyFilters = {
    beginDate: null,
    endDate  : null
  };

  productFilters = {
    limit : null,
    offset: 0
  };

  constructor (
    private exportService   : ExportService,
    private messagesService : MessagesService,
    private translateService: TranslateService
  ) {}

  exportCustomers () : void {
    this.exportService.customers()
    .then(( email : string ) => this.messagesService.show(this.translateService.instant('EXPORT_SPACE.EXPORT_EMAIL_CONFIRM', {
      email: email
    }), 'success'))
    .catch(error => this.messagesService.error(error));
  }

  exportHistory () : void {
    this.exportService.invoices(this.historyFilters)
    .then(( email : string ) => this.messagesService.show(this.translateService.instant('EXPORT_SPACE.EXPORT_EMAIL_CONFIRM', {
      email: email
    }), 'success'))
    .catch(error => this.messagesService.error(error));
  }

  exportHistoryItems () : void {
    this.exportService.invoiceItems(this.historyFilters)
    .then(( email : string ) => this.messagesService.show(this.translateService.instant('EXPORT_SPACE.EXPORT_EMAIL_CONFIRM', {
      email: email
    }), 'success'))
    .catch(error => this.messagesService.error(error));
  }

  exportProducts () : void {
    this.exportService.products(this.productFilters)
    .then(( email : string ) => this.messagesService.show(this.translateService.instant('EXPORT_SPACE.EXPORT_EMAIL_CONFIRM', {
      email: email
    }), 'success'))
    .catch(error => this.messagesService.error(error));
  }

  exportVehicles () : void {
    this.exportService.vehicles()
    .then(( email : string ) => this.messagesService.show(this.translateService.instant('EXPORT_SPACE.EXPORT_EMAIL_CONFIRM', {
      email: email
    }), 'success'))
    .catch(error => this.messagesService.error(error));
  }

  exportVendors () : void {
    this.exportService.vendors()
    .then(( email : string ) => this.messagesService.show(this.translateService.instant('EXPORT_SPACE.EXPORT_EMAIL_CONFIRM', {
      email: email
    }), 'success'))
    .catch(error => this.messagesService.error(error));
  }
}
